var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAttention(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9849 0.002458C8.04599 0.0505705 5.24402 1.25331 3.18475 3.35066C1.10287 5.42333 -0.0463114 8.25367 0.00143031 11.1909C-0.0019842 14.0598 1.13664 16.8121 3.16592 18.8401C5.1952 20.8681 7.94823 22.0051 10.8172 22H11.0134C17.1346 21.937 22.0495 16.9308 21.9996 10.8097C22.0065 7.90521 20.8414 5.12078 18.7682 3.08661C16.695 1.05243 13.8888 -0.0595099 10.9849 0.002458ZM9.62564 15.1643C9.61229 14.8012 9.74552 14.4481 9.99533 14.1843C10.2451 13.9205 10.5905 13.7683 10.9538 13.7619H10.9785C11.7302 13.7634 12.3464 14.3582 12.3745 15.1093C12.3881 15.4724 12.255 15.8257 12.0051 16.0895C11.7552 16.3533 11.4097 16.5054 11.0464 16.5116H11.0216C10.2704 16.5092 9.65462 15.9149 9.62564 15.1643ZM10.084 5.96011V11.4595C10.084 11.9657 10.4943 12.3761 11.0005 12.3761C11.5068 12.3761 11.9171 11.9657 11.9171 11.4595V5.96011C11.9171 5.45391 11.5068 5.04355 11.0005 5.04355C10.4943 5.04355 10.084 5.45391 10.084 5.96011Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttention);
export default __webpack_public_path__ + "static/media/icon-attention.66a6a881d42bb087b640e3b3f2a76869.svg";
export { ForwardRef as ReactComponent };